/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, Fragment, useCallback, useEffect, useMemo, useRef } from "react";
import { Button, Icon, List, Text, useTheme } from "@bookingcom/bui-react";
import { useHistory, useLocation } from "react-router-dom";
import { I18nChildContext, Trans, useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { UIClientFetchError, UIFlightData } from "@flights/types";
import FlightCardMobile from "../FlightCard/FlightCard.mobile";
import { SearchPaginationMobile } from "../SearchPagination";
import { SearchRemoveIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { SkeletonFlightCard } from "../Skeleton/SkeletonFlightCard";
import { TooManyFilters } from "./components/TooManyFilters";
import { NoResultsFound } from "./components/NoResultsFound";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../../../store";
import { getExpandedSearchAirports } from "../../../store/selectors/expandedSearch";
import { FILTERS } from "../../../constants";
import { RemoveDirectFlights } from "./components/RemoveDirectFlights";
import useCreateUrl from "../../../hooks/useCreateUrl";
import SearchBaggagePolicies from "../SearchBaggagePolicies";
import useClientCachedURL from "../../../hooks/useClientCachedURL";
import RefreshResults from "./components/RefreshResults";
import NoDirectFlightsBanner from "./components/NoDirectFlightsBanner";
import useGlobalContext from "../../../hooks/useGlobalContext";
import useEventTracking from "../../../hooks/useEventTracking";
import { SearchLoadingMessage, SearchLoadingSouthwest } from "../SearchLoadingMessage";
import { getLocationParams } from "./utils";
import GeniusTCBanner from "../../../cross-sell/components/GeniusTCBanner";
import Frame from "../Frame";
import { FlightCampaignTCBanner } from "../FlightCampaignTCBanner";
import { flightsSessionStore, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { FlexibleDateBestPrice } from "../FlexibleDateBestPrice";
import styles from "./SearchResults.module.css";
import { useFlexDatesRectrictedPOS } from "../FlexibleDateBestPrice/useFlexDatesRectrictedPOS";
import { RemoteAppleCardSR } from "../../remote";
import flights_apex_web_ancillaries_micro_conversion_aa from "../../../utils/experiments/apex/flights_apex_web_ancillaries_micro_conversion_aa";
import useOfferCartOrderData from "../../../hooks/useOfferCartOrderData";
import useAlternativeFaresParams from "../../../hooks/useAlternativeFaresParams";
import { useSelector } from "react-redux";
import { getEsimEligibilitySearch } from "../../../ancillaries/store/esim/selectors";
import flights_ace_web_esim_banner, {
  useTrackEsimBannerStages
} from "../../../utils/experiments/ace/flights_ace_web_esim_banner";
import EsimBanner from "../../../ancillaries/components/Esim/EsimBanner";
import useIsInViewport from "../../../hooks/useIsInViewport";
import Wrapper from "../../atoms/Wrapper";
import { useEsimSearch } from "../../../ancillaries/hooks/Esim/useEsimFetch";
import flights_mdotvalue_flight_details_back_button from "../../../utils/experiments/mdotvalue/flights_mdotvalue_flight_details_back_button";
import useTrackFlightsFlexiBannerSourceChange from "../../../utils/experiments/funnel/flights_web_flexi_banner_source_change_ml";
import useFlightsWebSrNewFlexPriceMlModel from "../../../utils/experiments/funnel/flights_web_sr_new_flex_price_ml_model";
import { useStickySearchBoxExp } from "../../../utils/experiments/mdotvalue/flights_mdotvalue_sr_sticky_search_box";

import flights_split_bounds_us, {
  useTrackSplitBoundsStages
} from "../../../utils/experiments/funnel/flights_split_bounds_us";
import useTrackFlightsWeb2StepRanker from "../../../utils/experiments/funnel/flights_web_2_step_ranker";
import useFlightsWebSouthwest from "../../../utils/experiments/funnel/flights_web_southwest";
import { useAppliedFilters } from "../../../hooks/search/useAppliedFilters";
import flights_web_aa_lack_of_choice from "../../../utils/experiments/funnel/flights_web_aa_lack_of_choice";

type SearchResultsListProps = {
  flights: UIFlightData[];
  onSelectFlight: (flight: any) => void;
  dataTestId?: string;
};

function _SearchResultsList({ flights, onSelectFlight, dataTestId }: SearchResultsListProps) {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const {
    searchResults: { campaignBanner, remoteBanners, displayOptions }
  } = store;
  const isRestricedFlexDatePOS = useFlexDatesRectrictedPOS();
  const params = new URLSearchParams(location.search);
  const currentSearchResultsPageNumber = params.get("page");

  /* start - flights_split_bounds_us */
  useTrackSplitBoundsStages();
  /* end - flights_split_bounds_us */

  const { trackStages } = useTrackFlightsFlexiBannerSourceChange(); // flights_web_flexi_banner_source_change_ml
  const { trackStages: trackNewStages } = useFlightsWebSrNewFlexPriceMlModel(); // flights_web_sr_new_flex_price_ml_model
  useEffect(() => {
    trackStages();
    trackNewStages();
  }, [trackStages, trackNewStages]);

  //There isn't a page param for the first search
  const isFirstSearchResultsPage = currentSearchResultsPageNumber ? Number(currentSearchResultsPageNumber) === 1 : true;

  useEffect(() => {
    flights_apex_web_ancillaries_micro_conversion_aa.trackSearchResultsStages(flights);
  }, [flights]); // eslint-disable-line react-hooks/exhaustive-deps

  const shouldShowFlexDates =
    !displayOptions?.hideFlexiblePricesBanner &&
    flights.length >= 5 &&
    store.search.cabinClass === "ECONOMY" &&
    isFirstSearchResultsPage &&
    !isRestricedFlexDatePOS;

  /** start - flights_ace_web_esim_banner */
  const isEsimEligible = !!useSelector(getEsimEligibilitySearch);
  const showEsimBanner = isEsimEligible && !!flights_ace_web_esim_banner.trackWithDefaultStage();
  const ESIM_BANNER_SEARCH_RESULTS_INDEX = 6;
  const fetchEsim = useEsimSearch();
  const esimBannerRef = useRef<HTMLDivElement>(null);
  const eSimInViewport = useIsInViewport(esimBannerRef.current);
  /** end - flights_ace_web_esim_banner */
  useTrackEsimBannerStages(isEsimEligible);

  /* start - flights_web_flexible_date_search */
  useEffect(() => {
    void fetchEsim();
  }, [fetchEsim]);

  useEffect(() => {
    if (eSimInViewport) {
      flights_ace_web_esim_banner.stages.viewed_esim_banner_sr_page();
      flights_ace_web_esim_banner.goals.viewed_esim_banner();
    }
  }, [eSimInViewport]);
  /* end - flights_web_ace_esim_banner */

  flights_web_aa_lack_of_choice.useTrackStages(flights);

  return (
    <div className={styles.searchResultsList} data-testid={dataTestId}>
      <List attributes={{ style: { padding: 0 } }}>
        {flights.map((flight: any, index: number) => {
          return (
            <Fragment key={`${index}_${flight.token}`}>
              {isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
              campaignBanner &&
              index === campaignBanner.position ? (
                <Frame>
                  <FlightCampaignTCBanner campaignBanner={campaignBanner} />
                </Frame>
              ) : null}

              <div id={`flightcard-${index}`} data-testid="searchresults_card">
                <FlightCardMobile
                  flight={flight}
                  index={index}
                  onClick={(flight) => {
                    onSelectFlight(flight);

                    if (isFirstSearchResultsPage) {
                      flights_web_aa_lack_of_choice.getExp(true).goals.firstPageClick();
                      flightsSessionStore.set("flights_web_aa_lack_of_choice_first_page_clicked", true);

                      if (index < 5) {
                        flights_web_aa_lack_of_choice.getExp(true).goals.topFiveClick();
                        flightsSessionStore.set("flights_web_aa_lack_of_choice_top_five_clicked", true);
                      }
                    }
                  }}
                  pricePerPerson
                />
              </div>
              <Frame>{shouldShowFlexDates && index === 0 ? <FlexibleDateBestPrice /> : null}</Frame>
              {/* If GeniusCampaign is Enabled, show the Genius TC campaign on 3rd position */}
              {!isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
              index === 1 &&
              campaignBanner ? (
                <Frame>
                  <GeniusTCBanner campaignBanner={campaignBanner} />
                  <SearchTrafficAAGeniusTrackerMdot />
                </Frame>
              ) : null}
              {/**
               * If the position is larger than the number of cards displayed in the SR page,
               * then the T&C banner is shown after the last card.
               * More info: https://jira.booking.com/jira/browse/FPRICING-809
               */}
              {isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
              campaignBanner &&
              campaignBanner.position >= flights.length && // campaign banner position is larger than the number of cards
              index >= flights.length - 1 ? ( // after the last flight card
                <Frame>
                  <FlightCampaignTCBanner campaignBanner={campaignBanner} />
                </Frame>
              ) : null}
              {/* start - flights_ace_web_esim_banner */}
              {showEsimBanner && index === ESIM_BANNER_SEARCH_RESULTS_INDEX ? (
                <Wrapper
                  elementRef={esimBannerRef}
                  noBorder
                  noPadding
                  noPaddingVertical
                  style={{ paddingBottom: "8px" }}
                >
                  <EsimBanner context="search" />
                </Wrapper>
              ) : null}
              {/* end - flights_ace_web_esim_banner */}

              {Array.isArray(remoteBanners) && remoteBanners.includes("APPLE_CARD_BANNER_SR") && index === 4 ? (
                <RemoteAppleCardSR />
              ) : undefined}
            </Fragment>
          );
        })}
      </List>
    </div>
  );
}

const SearchResultsList = React.memo(_SearchResultsList);

interface SearchResultsProps {
  airports: string;
  params: string;
  fetchStatus: string;
  fetchError?: UIClientFetchError;
  flights: UIFlightData[];
  onSelectFlight: () => void;
}

const SearchResults = ({ airports, params, flights = [], fetchStatus, onSelectFlight }: SearchResultsProps) => {
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const { createUrl } = useCreateUrl();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const {
    search,
    searchResults,
    flexibleDateMinPrice: { fetchStatus: flexibleDatePriceFetchStatus }
  } = store;
  const { error } = searchResults;
  const appliedFilters = useAppliedFilters();
  const i18n = useI18n() as I18nChildContext;
  const { cacheLastSuccessfulSearchUrl } = useClientCachedURL();
  const { requestId } = useGlobalContext();
  const trackV2 = useEventTracking("search_results", requestId);
  const isRestricedFlexDatePOS = useFlexDatesRectrictedPOS();
  const offerCartOrderData = useOfferCartOrderData();
  const { setAlternativeFaresParams } = useAlternativeFaresParams();

  /*@start flights_mdotvalue_sr_sticky_search_box*/
  const { trackReachedEndOfPage } = useStickySearchBoxExp();
  const endOfPageRef = useRef(null);
  const reachedEndOfPage = useIsInViewport(endOfPageRef.current);

  const flightsWebSouthwest = useFlightsWebSouthwest();

  useEffect(() => {
    if (reachedEndOfPage) {
      trackReachedEndOfPage();
    }
  }, [reachedEndOfPage, trackReachedEndOfPage]);
  /*@end flights_mdotvalue_sr_sticky_search_box*/

  useEffect(() => {
    // START - flights_mdotvalue_flight_details_back_button
    if (flightsSessionStore.get("clickedFlightDetails")) {
      flights_mdotvalue_flight_details_back_button.goals.onBackToSr();
      flights_mdotvalue_flight_details_back_button.goals.onFlightExit();
    }
    flightsSessionStore.set("clickedFlightDetails", false);
    // END - flights_mdotvalue_flight_details_back_button

    if (["loading", "initial"].includes(fetchStatus)) return;
    if (flights.length === 0) trackV2("show_empty_search_results");
  }, [flights, fetchStatus, trackV2]);

  /* start - flights_web_2_step_ranker */
  const trackFlightsWeb2StepRanker = useTrackFlightsWeb2StepRanker();
  useEffect(() => {
    trackFlightsWeb2StepRanker.trackStages();
  }, [trackFlightsWeb2StepRanker]);
  /* end - flights_web_2_step_ranker */

  const showFlightDetails = useCallback(
    async (flight: any) => {
      trackFlightsWeb2StepRanker.onClick(flight.token);
      flights_split_bounds_us.goals.cta_click();

      onSelectFlight();

      // flights_mdotvalue_flight_details_back_button
      flightsSessionStore.set("clickedFlightDetails", true);

      offerCartOrderData.set(flight.token, {
        offer: flight.token,
        cabinClass: searchResults.searchCriteria?.cabinClass
      });
      history.push(createUrl(`/flights/${airports}/${flight.token}/?${getLocationParams(params)}`), {
        fromSearch: true
      });
    },
    [
      onSelectFlight,
      offerCartOrderData,
      searchResults.searchCriteria?.cabinClass,
      history,
      createUrl,
      airports,
      params,
      trackFlightsWeb2StepRanker
    ]
  );

  const changeSearch = useCallback(() => {
    history.push(createUrl("/"));
  }, [history, createUrl]);

  const expandedSearchAirports = useMemo(() => {
    const { searchSegments } = search;
    /*eslint-disable-next-line flights/no-unassigned-todo-comments*/
    /**
     * TODO: Update ExpandedSeach for multistop cases?
     */
    const { from, to } = searchSegments[0];
    return getExpandedSearchAirports(from, to);
  }, [search]);

  const expandToCitySearch = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (expandedSearchAirports) {
        const { fromCities, toCities, fromLocationName, toLocationName } = expandedSearchAirports;
        const params = new URLSearchParams(location.search);
        params.set("from", fromCities);
        params.set("to", toCities);
        params.set("fromLocationName", fromLocationName);
        params.set("toLocationName", toLocationName);

        history.replace(createUrl(`/flights/${fromCities}-${toCities}/?${params}`));
        window.location.reload();
      }
    },
    [history, location, expandedSearchAirports, createUrl]
  );

  // @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely.
  const noFlightsFound = error && error["code"] === "SEARCH_SEARCHFLIGHTS_NO_FLIGHTS_FOUND";
  const canExtendSearch = appliedFilters.length === 0 && noFlightsFound && expandedSearchAirports;
  const canRemoveDirectFlightsFilter = appliedFilters.includes(FILTERS.stops) && flights.length === 0;

  const flexibleLoadingCondition =
    store.search.cabinClass === "ECONOMY" && !isRestricedFlexDatePOS
      ? flexibleDatePriceFetchStatus === "initial" || flexibleDatePriceFetchStatus === "loading"
      : false;

  useEffect(() => {
    if (fetchStatus === "initial" || fetchStatus === "loading" || flexibleLoadingCondition) {
      flightsWebSouthwest.trackStages();
    }
  }, [fetchStatus, flexibleLoadingCondition, flightsWebSouthwest]);

  if (fetchStatus === "initial" || fetchStatus === "loading" || flexibleLoadingCondition) {
    return (
      <>
        <SearchLoadingMessage />
        {flightsWebSouthwest.isVariant ? <SearchLoadingSouthwest /> : undefined}
        <div className={styles.loading}>
          <SkeletonFlightCard />
          <SkeletonFlightCard />
          <SkeletonFlightCard />
          <SkeletonFlightCard />
        </div>
      </>
    );
  }

  if (fetchStatus === "success") {
    if (flights.length > 0) {
      cacheLastSuccessfulSearchUrl(airports);
      searchResults.fetchedAt && setAlternativeFaresParams("searchedAt", searchResults.fetchedAt);
      return (
        <div className={styles.searchResults}>
          <NoDirectFlightsBanner />
          <SearchBaggagePolicies />
          <SearchResultsList flights={flights} onSelectFlight={showFlightDetails} dataTestId="searchresults_list" />
          {/*@start flights_mdotvalue_sr_sticky_search_box*/}
          <div ref={endOfPageRef}></div>
          {/*@end flights_mdotvalue_sr_sticky_search_box*/}
          <SearchPaginationMobile />
          <RefreshResults flights={flights} />
        </div>
      );
    } else if (canRemoveDirectFlightsFilter) {
      return <RemoveDirectFlights />;
    }
  }

  if (fetchStatus === "failed") {
    if (canExtendSearch) {
      return (
        <Frame mt={6} mb={6} attributes={{ style: { minHeight: "40vh" } }}>
          <Frame m={3} alignItems="center" attributes={{ style: { textAlign: "center" } }}>
            <Icon svg={SearchRemoveIcon} size="small" className={styles.searchRemoveIcon} />
            <Text variant="headline_2">{i18n.trans(t("flights_search_no_results_header"))} </Text>
          </Frame>
          {search.type !== "MULTISTOP" && (
            <Text variant="body_2">
              <Trans
                tag="flights_search_no_results_copy_mobile"
                variables={{ start_link: "<0>", end_link: "</0>" }}
                components={[
                  <a
                    key={0}
                    href="##"
                    style={{ color: theme.colors.color_action_foreground }}
                    onClick={expandToCitySearch}
                  />
                ]}
              />
            </Text>
          )}
          <Frame alignItems="center" m={6}>
            <Button onClick={changeSearch}>{i18n.trans(t("flights_search_no_results_change_search_cta"))}</Button>
          </Frame>
        </Frame>
      );
    }
  }

  if (appliedFilters.length > 0) {
    return <TooManyFilters />;
  } else {
    return <NoResultsFound showActions={true} />;
  }
};

export const SearchTrafficAAGeniusTrackerMdot: FC = () => {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();

  useEffect(() => {
    if (!store.user.userInfo) {
      flightsSessionStore.set("genius_banner_seen", true);
    }
  }, [store.user.userInfo]);

  return null;
};

export default React.memo(SearchResults);
